// AUTO-GENERATED from /app/docs/legal/04_POLITICA_DE_COOKIES.md. Do not edit by hand.
export default `# Política de Cookies — BlueGov

**Versão simplificada · Fevereiro/2026**

## Visão Geral
O BlueGov **não utiliza cookies de marketing, rastreamento publicitário ou análise de comportamento de terceiros**. A plataforma foi projetada para operar com o mínimo de armazenamento local possível e sem trackers externos.

## O que utilizamos

### Armazenamento técnico estritamente necessário
- **Token JWT da sessão**: armazenado em \`localStorage\` do navegador, exclusivamente para manter o usuário autenticado durante o uso.
- **Rascunho do Wizard de Criação de Ato** (chave \`bluegov_wizard_create_act_draft_v1\`): armazenado em \`localStorage\` para evitar perda de digitação caso o usuário recarregue a página.

Esses dados ficam **no navegador do usuário**, não são enviados para servidores de terceiros e podem ser apagados a qualquer momento pelo próprio usuário nas configurações do navegador (ou pelo botão **"Descartar"** no Wizard).

## O que NÃO utilizamos
- ❌ Google Analytics / gtag
- ❌ Microsoft Clarity
- ❌ Hotjar
- ❌ Meta Pixel / Facebook Pixel
- ❌ Mixpanel, Amplitude, Segment, PostHog
- ❌ Cookies de marketing, retargeting ou publicidade
- ❌ Cookies de terceiros injetados pelo sistema

## Cookies definidos pelo navegador/infraestrutura
- O **Railway** (provedor de hospedagem) e o **Cloudflare/CDN** (quando aplicável) podem definir cookies técnicos de balanceamento e proteção contra abuso. Esses cookies são necessários para a operação segura da aplicação e não rastreiam o usuário individualmente.

## Como gerenciar
- Limpe o \`localStorage\` em **Configurações do navegador → Privacidade → Limpar dados de navegação**.
- Use o botão **"Descartar"** no Wizard para limpar o rascunho a qualquer momento.
- Para sair da sessão: use o botão **"Sair"** ou apague o token do \`localStorage\`.

## Contato
**DPO:** dpo@bluegov.com.br
`;
